/**
 * Creates a guard that deduplicates consecutive calls with the same value.
 * Returns `true` if the value is the same as the last call (skip),
 * `false` if it's new (proceed).
 *
 * Used to protect `afterNavigate` callbacks against a SvelteKit bug
 * that fires the callback multiple times for the same navigation.
 * @see https://github.com/sveltejs/kit/issues/13573
 */
export const createPageGuard = (): ((value: string) => boolean) => {
    let lastValue: string | null = null;

    return (value: string): boolean => {
        if (value === lastValue) return true;
        lastValue = value;
        return false;
    };
};
